module.exports = __webpack_public_path__ + "img/prevent.de66b24.svg";